import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Drawer, Table, Popover, Divider, Modal, Button, Spin } from 'antd';
import { isMobile } from 'react-device-detect';
import { isValidDate } from '@/utils/helpers';
import { DeleteOutlined, DownOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import NumberFormat from 'react-number-format';
import { checkPermission } from '@/utils/permission';
import { removeAdditionalCost, getSpecificAdditionalCost, getAdditionalCostCustomer } from '@/redux/actions/AdditionalCost';
import ExpandableText from '@/components/ExpandableText';
import AdditionalCostForm from './AdditionalCostForm';

const { confirm } = Modal;

class AdditionalCost extends Component {
    constructor() {
        super();
        this.state = {
            isOpenForm: false,
            currentItem: null,

            loading: false,
            items: [], // list nội bộ
        };
    }

    componentDidMount() {
        const { visible, customerId } = this.props;
        if (visible && customerId) this.loadData();
    }

    componentDidUpdate(prevProps) {
        const { visible, customerId } = this.props;

        const justOpened = !prevProps.visible && visible;
        const changedCustomer = prevProps.customerId !== customerId;

        if (visible && customerId && (justOpened || changedCustomer)) {
            this.loadData();
        }

        if (prevProps.visible && !visible) {
            this.setState({ isOpenForm: false, currentItem: null });
        }
    }

    loadData = async () => {
        const { customerId } = this.props;
        if (!customerId) return;

        this.setState({ loading: true });
        try {
            const items = await this.props.getAdditionalCostCustomer(customerId);
            this.setState({ items: items || [], loading: false });
        } catch (e) {
            this.setState({ loading: false });
        }
    };

    toggleOpenForm(isOpenForm, currentItem = null) {
        this.setState({ isOpenForm, currentItem });
    }

    onEdit(id) {
        this.props.getSpecificAdditionalCost(id).then((res) => {
            this.toggleOpenForm(true, res);
        });
    }

    onRemove(id) {
        confirm({
            title: 'Cảnh báo',
            content: 'Bạn chắc chắn muốn xoá bản ghi này?',
            okText: 'OK',
            cancelText: 'Huỷ',
            onOk: async () => {
                await this.props.removeAdditionalCost(id);
                await this.loadData(); // tự reload
                setTimeout(() => Modal.destroyAll(), 300);
            },
        });
    }

    onClose() {
        this.props.onCancel();
    }

    render() {
        const { isOpenForm, currentItem, loading, items } = this.state;
        const { visible, customerId } = this.props;

        const columns = [
            {
                title: '#',
                width: '80px',
                align: 'center',
                render: (_, record) => (
                    <div>
                        {checkPermission('additional_cost', 'update') ? (
                            <>
                                <EditOutlined
                                    className='color-primary'
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => this.onEdit(record.id)}
                                />
                                <Divider type='vertical' />
                            </>
                        ) : null}

                        {checkPermission('additional_cost', 'remove') ? (
                            <DeleteOutlined
                                style={{ color: 'red', cursor: 'pointer' }}
                                onClick={() => this.onRemove(record.id)} // ✅ 1 id
                            />
                        ) : null}
                    </div>
                ),
            },
            {
                title: 'Tên',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Dịch vụ áp dụng',
                dataIndex: 'cost_service',
                key: 'cost_service',
                width: '150px',
                render: (_, record) => {
                    const services = record?.cost_service;
                    if (!services?.length) return (<div style={{ color: '#0a4e8f' }}>Tất cả</div>);

                    const content = services.map((item, index) => (
                        <div key={index} style={{ padding: '5px 0' }}>
                            {item.customer_service?.service?.name}
                        </div>
                    ));

                    return (
                        <div className='item-action-btn'>
                            <Popover placement="right" content={content}>
                                {services[0]?.customer_service?.service?.name} <DownOutlined />
                            </Popover>
                        </div>
                    );
                },
            },
            {
                title: 'Số tiền',
                dataIndex: 'amount',
                key: 'amount',
                width: '120px',
                render: (text) => (
                    <NumberFormat value={text} displayType={'text'} suffix="đ" thousandSeparator />
                ),
            },
            {
                title: 'Ghi chú',
                dataIndex: 'note',
                key: 'note',
                width: '200px',
                render: (text) => <ExpandableText text={text} rows={1} />,
            },
            {
                title: 'Ngày tạo',
                dataIndex: 'created_at',
                key: 'created_at',
                width: '150px',
                render: (text) => <>{isValidDate(text, true)}</>,
            },
            {
                title: 'Người tạo',
                dataIndex: 'created_user',
                key: 'created_user',
                width: '200px',
                render: (_, record) => <>{record?.created_user?.full_name}</>,
            },
        ];

        return (
            <>
                <Drawer
                    visible={visible}
                    title="Chi phí bổ sung"
                    onClose={() => this.onClose()}
                    maskClosable={false}
                    width={isMobile ? '100%' : '75%'}
                >
                    {visible ? (
                        <Spin spinning={loading}>
                            <Button
                                type='primary'
                                icon={<PlusOutlined />}
                                onClick={() => this.toggleOpenForm(true)}
                                className='mb-2'
                                disabled={!checkPermission('additional_cost', 'add')}
                            >
                                Thêm mới
                            </Button>

                            <Table
                                size='small'
                                rowKey='id'          // đúng key
                                tableLayout="auto"
                                columns={columns}
                                dataSource={items || []}
                                pagination={false}
                                scroll={{ x: 'max-content' }}
                                className='mb-4 w-100'
                                locale={{ emptyText: "Chưa có dữ liệu" }}
                            />
                        </Spin>
                    ) : null}
                </Drawer>

                <AdditionalCostForm
                    visible={isOpenForm}
                    customerId={customerId}
                    data={items}
                    onCancel={() => this.toggleOpenForm(false)}
                    currentItem={currentItem}
                    reloadData={() => this.loadData()} // reload list sau submit
                />
            </>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        removeAdditionalCost: (id) => dispatch(removeAdditionalCost(id)),
        getSpecificAdditionalCost: (id) => dispatch(getSpecificAdditionalCost(id)),
        getAdditionalCostCustomer: (customerId) => dispatch(getAdditionalCostCustomer(customerId)),
    };
}

export default connect(null, mapDispatchToProps)(AdditionalCost);